import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 7816CE91-EBD1-4136-8523-CF47F677F4C6
 * name keyboard-return
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/keyboard-return.svg
 * tags
 */
export const KeyboardReturnIcon = createSvgIcon(<><path d="M19,7V11H5.83L9.41,7.41L8,6L2,12L8,18L9.41,16.58L5.83,13H21V7H19Z" /></>, 'KeyboardReturnIcon');
export default KeyboardReturnIcon